var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigoLogoRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-6{fill:#fff;}.cls-2{stroke:#000;stroke-opacity:0.1;stroke-width:0.5px;}.cls-3{mask:url(#mask);}.cls-4{fill:#73dad2;}.cls-4,.cls-5,.cls-6{fill-rule:evenodd;}.cls-5{fill:#22435e;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    className: "cls-1",
    width: 52,
    height: 52,
    rx: 13.97
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brand-_-Logo-_-Favicon",
    "data-name": "Brand-/-Logo-/-Favicon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "F-Tag"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.25,
    y: 0.25,
    width: 51.5,
    height: 51.5,
    rx: 13.97
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG-Angle",
    className: "cls-4",
    d: "M52,14.09V37.8A14.2,14.2,0,0,1,37.8,52H14.2A14.21,14.21,0,0,1,.83,42.59L47.9,4.1A14.19,14.19,0,0,1,52,14.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shield",
    className: "cls-5",
    d: "M26,45.79l-.17-.52h0a.75.75,0,0,1-.35-.19C23.63,43.57,15,36.61,12.42,29.24a25.42,25.42,0,0,1-1.41-8v-11a.5.5,0,0,1,.37-.49h0A57,57,0,0,1,25.85,8H26A56.54,56.54,0,0,1,40.36,9.76a.49.49,0,0,1,.37.48v11a25.56,25.56,0,0,1-1.4,8C36.7,36.83,27.63,44,26.22,45.08a.67.67,0,0,1-.35.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    className: "cls-6",
    d: "M19.66,16.63a.47.47,0,0,0-.47.48V30.55a.47.47,0,0,0,.47.48h1.77a.47.47,0,0,0,.46-.48V24.81a.19.19,0,0,1,.19-.18h7.67a.47.47,0,0,0,.46-.48V23a.47.47,0,0,0-.46-.48H22.08a.19.19,0,0,1-.19-.18V19a.19.19,0,0,1,.19-.19H34.9a.47.47,0,0,0,.47-.48V17.1a.45.45,0,0,0-.14-.33.41.41,0,0,0-.33-.15Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigoLogoRound);
export default __webpack_public_path__ + "static/media/figo-logo-round.75a583a0bbb4b96006bdaecbfba08069.svg";
export { ForwardRef as ReactComponent };